<template>
    <div class="body-panel dataContent">
        <template v-if="task != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex top-menu">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <template v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.tasksEdit) || hasClaims(info.User.DynamicRole, claimEnums.tasksController) || info.User.MainRole === 'administrators')">
                            <div class="form-field margin-right-20">
                                <drop-down class=""
                                           :items="statuses"
                                           :dataField="'Id'"
                                           :textField="'Name'"
                                           v-model="statusId"
                                           @change="onStatusChange($event)"></drop-down>
                            </div>
                            <div class="form-field margin-right-20">
                                <drop-down class=""
                                           :items="dateTypes"
                                           :dataField="'Id'"
                                           :textField="'Name'"
                                           v-model="dateTypeId"
                                           @change="onStatusChange($event)"></drop-down>
                            </div>
                            <div class="form-field flex">
                                <input-date name="dateStart" v-model="dateStart" @input="onDateChange" class="input-text input-date" todayHighlight="true"></input-date>
                                <span class="margin-left-10 margin-right-10 margin-top-5">-</span>
                                <input-date name="dateEnd" v-model="dateEnd" @input="onDateChange" class="input-text input-date" todayHighlight="true"></input-date>
                            </div>
                            <div class="form-field margin-left-20" v-if="statusId || dateStart || dateEnd || dateTypeId">
                                <button type="button" class="btn" @click="clearFilterState">Сбросить</button>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="control-block-right">
                    <div :class="{'flex': !isMobile}">
                        <div style="margin: auto 10px;" v-if="selectedAnswers.length">
                          Выбрано {{ selectedAnswers.length }} из {{ answers.length }}
                        </div>
                        <button type="button" class="btn btn-primary" @click="updateMultipleAnswerStatuses(2, '')" v-if="selectedAnswers.length">Принять</button>
                        <button type="button" class="btn btn-delete" @click="btnReject(4)" v-if="selectedAnswers.length">Доработать</button>
                        <button type="button" class="btn btn-delete" @click="btnReject(5)" v-if="selectedAnswers.length">Отклонить</button>
                        <button type="button" class="btn" @click="selectedCancel()" v-if="selectedAnswers.length">Отмена</button>
                        <button type="button" class="btn btn-delete" @click="removeAnswers()" v-if="selectedAnswers.length">Удалить</button>
                        <button class="btn" @click="onDetailExport()" v-if="exportEnabled">
                            Выгрузка по отчетам
                        </button>
                        <div :class="{'flex': !isMobile}" v-if="allowAdd" :key="detail.ResponsibleId">
                            <p class="caption-help margin-right-10">{{ pageInfoMessage }}</p>
                            <div class="btns flex" v-if="!detail.ResponsibleBlock">
                                <button type="button" class="btn btn-primary" @click="confirmShow('setResponsible')" v-if="task.PurposeOneAnswerTT && detail.ResponsibleId == null">{{ detail.AnswerBtnAddText }}</button>
                                <button type="button" class="btn btn-primary" @click="confirmShow('setRefuse')" v-if="task.PurposeOneAnswerTT && detail.AllowResponsibleAdd">Отказаться от выполнения</button>
                                <button type="button" class="btn btn-primary" @click="addAnswer" v-if="!task.PurposeOneAnswerTT || detail.AllowResponsibleAdd">{{ detail.AnswerBtnAddText }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="body-panel-control-separator" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.tasksEdit) || hasClaims(info.User.DynamicRole, claimEnums.tasksController) || info.User.MainRole === 'administrators')">
                    <complex-filter ref="complexFilter"
                                    :cacheKey="'reportsComplexFilter'"
                                    :filters="userFilters"
                                    :searchFunction="searchFunction"
                                    :tableName="'[dbo].[AspNetUsers]'"
                                    @onFilterChange="onFilterChange"
                                    :withTableNameInClause="true"></complex-filter>
                </div>
                <div class="body-panel-control-separator" v-if="task.PurposeOneAnswerTT && allowAdd">
                    <label class="input-text-lbl margin-bottom-5">Торговая точка</label>
                    <search-filter :name="'TradePointName'"
                                   v-validate="{ rules: { required: true} }"
                                   :hasErrors="errors.has('TradePointName')"
                                   :extra="0"
                                   :placeholder="'Выберите точку из списка'"
                                   :searchFunction="searchTPFunction"
                                   :selectedItem="getTPSelectedItem(tradePointSelected)"
                                   :searchOnSelect="true"
                                   :scrollable="true"
                                   :disabled="detail.MyTradePoints.length < 2"
                                   @onFilterChange="onChangeTPSearch(...arguments)"></search-filter>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page" @scroll="onScroll">
                <div style="width:100%">
                    <h1 class="margin-bottom-20">{{task.Name}}</h1>
                </div>
                <div class="flex mob-flex-to-block">
                    <div class="block-in-page task-content-info">
                        <div class="block-in-page-detail">
                            <div class="flex">
                                <h2 style="width:80%">{{ task.TaskType === TaskTypes.Simple ? 'Количество выполнений' : 'Прогресс выполнения' }}</h2>
                                <h2 style="width:20%;text-align:right">{{ bonus.QntDone }} {{task.TaskType === TaskTypes.Cumulative ? '%' : ''}}</h2>
                            </div>
                            <div class="margin-top-10">
                                <span class="caption-help">Дата начала: {{ task.StartDateFormatted }}</span>
                                <span class="caption-help margin-left-10">{{ task.StateText }}</span>
                            </div>
                            <div class="margin-top-10">
                                <div class="task-count green">
                                    <span>Принято</span>
                                    <span>{{ bonus.QntFact }}</span>
                                </div>
                                <div class="task-count red">
                                    <span>Отклонено</span>
                                    <span>{{ bonus.QntRejected }}</span>
                                </div>
                                <div class="task-count blue">
                                    <span>На доработке</span>
                                    <span>{{ bonus.QntBeingFinalized }}</span>
                                </div>
                                <div class="task-count yellow">
                                    <span>Ждет проверки</span>
                                    <span>{{ bonus.QntWaitingVerification }}</span>
                                </div>
                            </div>
                            <template v-if="task.TaskType === TaskTypes.Cumulative">
                                <div class="line-separator margin-bottom-15 margin-top-10"></div>
                                <div>
                                    <div class="tasks-progress margin-top-5">
                                        <div class="tasks-progress-line" :style="{width: bonus.QntDone + '%'}"></div>
                                    </div>
                                    <div class="flex margin-top-5">
                                        <div style="width:50%">
                                            <p class="input-text-lbl">План: {{ bonus.PurposeValue }}</p>
                                        </div>
                                        <div style="width:50%">
                                            <p style="text-align:right">Факт: {{ bonus.Fact }}</p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="task.ScoringAccrual === ScoringAccrualTypes.DependingOnSku || task.ScoringAccrualSumText!=='0'">
                                <div class="line-separator margin-bottom-15 margin-top-10"></div>
                                <div class="flex">
                                    <div style="width:50%">
                                        <p class="input-text-lbl">Баллов за выполнение</p>
                                        <!--<p class="input-text-lbl first-uppercase">{{task.ScoringAccrualText.length === 0 ? 'Баллов за выполнение' : task.ScoringAccrualText}}</p>-->
                                        <div :class="[task.ScoringAccrual === ScoringAccrualTypes.DependingOnSku ? 'fz-24' : 'fz-50']">{{task.ScoringAccrualSumText}}</div>
                                        <div class="margin-top-15" v-if="task.ScoringAccrual === ScoringAccrualTypes.DependingOnSku">
                                            <a class="reglink" @click="moreSKU"><span>подробнее</span></a>
                                        </div>
                                    </div>
                                    <div style="width:50%">
                                        <p class="input-text-lbl">Баллов получено</p>
                                        <div style="color:#32D673;font-size:50px">{{ bonus.Scoring }}</div>
                                    </div>
                                </div>
                            </template>
                            <div class="line-separator margin-bottom-15 margin-top-15"></div>
                            <div>
                                <p class="task-header">Описание задачи</p>
                                <p class="caption-help" v-html="task.CaptionFormatted"></p>
                            </div>
                            <template v-if="taskAttachmentsImage.length > 0 || taskAttachmentsNoImage.length > 0">
                                <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                <div class="form-field-group">
                                    <div class="form-field" v-if="taskAttachmentsNoImage.length > 0" style="width:50%">
                                        <p class="task-header">Файлы</p>
                                        <div class="flex" style="flex-wrap:wrap">
                                            <div class="task-photo" v-for="(item, i) of taskAttachmentsNoImage">
                                                <a target="_blank" :href="item.FilePath" class="task-photo-file">
                                                    <svg class="tasks-svg svg-icon" v-if="item.Extension==='docx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <use xlink:href="/Content/dist/image_svg.svg?v2#Docx" />
                                                    </svg>
                                                    <svg class="tasks-svg svg-icon" v-if="item.Extension==='xlsx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <use xlink:href="/Content/dist/image_svg.svg?v2#Xlsx" />
                                                    </svg>
                                                    <svg class="tasks-svg svg-icon" v-if="item.Extension==='pdf'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <use xlink:href="/Content/dist/image_svg.svg?v2#Pdf" />
                                                    </svg>
                                                    <span>{{item.FileName}}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field" v-if="taskAttachmentsImage.length > 0" style="width:50%">
                                        <p class="task-header">Фото</p>
                                        <div class="flex" style="flex-wrap:wrap">
                                            <div class="task-photo" v-for="(item, i) of taskAttachmentsImage">
                                                <a target="_blank" :href="item.FilePath" class="lightzoom" rel="group">
                                                    <img :src="item.FilePath" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="block-in-page task-content-answer">
                        <h2>Ответы</h2>
                        <table class="table-view margin-top-10" id="dataTable">
                            <thead class="head-show">
                                <tr class="heading">
                                    <th class="check" v-if="hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)">
                                      <input id="selectAll" name="selectAll" value="true" type="checkbox" class="input-checkbox"
                                             v-model="selectAll" @change="onSelectAllChange($event)" />
                                      <label for="selectAll" class="input-checkbox-lbl"></label>
                                    </th>
                                    <th>ID</th>
                                    <th v-if="task.FixTT">Торговая точка</th>
                                    <th v-if="canBeShowFIO">Пользователь</th>
                                    <th>Дан ответ</th>
                                    <th>Статус</th>
                                    <th>Изменен статус</th>
                                    <th >Начислено баллов</th>
                                    <th ></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item, i) of answers">
                                    <!--
                                    <template v-if="isMobile">
                                        <tr>
                                            <td class="id">{{ item.Id }}</td>
                                        </tr>
                                        <tr v-if="task.FixTT">
                                            <td class="string" colspan="3" style="width:100%;min-width:100%">{{ item.ttName }}</td>
                                        </tr>
                                        <tr v-if="canBeShowFIO">
                                            <td class="string" colspan="3" style="width:100%;min-width:100%">{{ item.User.Fio }}</td>
                                        </tr>
                                        <tr>
                                            <td class="date">{{ item.FillingDate | date-short }}</td>
                                            <td :class="['state', getStateClass(item)]">{{ item.LastStatusFormatted }}</td>
                                            <td class="date">{{ item.DateStatus | date-short }}</td>
                                        </tr>
                                        <tr>
                                            <td class="value" colspan="1"><span v-if="task.TaskType === TaskTypes.Simple">{{ item.Scoring }}</span></td>
                                            <td class="obtn" colspan="2" style="min-width:unset;width:auto;text-align:right">
                                                <button type="button" class="btn" title="Открыть" @click.stop="editAnswer(item.Id, item.LastStatus)" style="display:inline-block">Открыть</button>
                                            </td>
                                        </tr>
                                    </template>
                                    -->
                                    <template>
                                        <tr @click.stop="editAnswer(item.Id, item.LastStatus)">
                                            <td class="check" @click.stop="" v-if="hasClaimsOrAdmin(info.User, claimEnums.tasksController) || hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)">
                                              <input :id="'select' + i" :value="item" type="checkbox" class="input-checkbox" v-model="selectedAnswers" @change="onCheckChange(item)" />
                                              <label :for="'select' + i" class="input-checkbox-lbl"></label>
                                            </td>
                                            <td class="id">{{ item.Id }}</td>
                                            <td class="string" v-if="task.FixTT">{{ item.ttName }}</td>
                                            <td class="string" v-if="canBeShowFIO">{{ item.User.Fio }}</td>
                                            <td class="date">{{ item.FillingDate | date-short }}</td>
                                            <td :class="['state', getStateClass(item)]">{{ item.LastStatusFormatted }}</td>
                                            <td class="date">{{ item.DateStatus | date-short }}</td>
                                            <td class="value">{{ item.Scoring }}</td>
                                            <td class="obtn-short-auto">
                                                <button type="button" class="btn" title="Открыть" @click.stop="editAnswer(item.Id, item.LastStatus)">Открыть</button>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>

        <popup-window ref="ppSkuList" :title="'Начисления баллов за каждое SKU'" width="800">
            <div>
                <table class="table-view margin-top-20">
                    <thead style="display: table-header-group !important;">
                        <tr>
                            <th>SKU</th>
                            <th>Баллы</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sku of skuBonusList">
                            <td>{{sku.SkuName}}</td>
                            <td class="valueshort">{{sku.Bonus}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <template v-slot:footer>
                <div class="popup-footer">
                    <div class="btns flex" data-toggle="buttons" style="justify-content: flex-end;">
                        <button type="button" class="btn" @click="closeModal('ppSkuList')">Закрыть</button>
                    </div>
                </div>
            </template>
        </popup-window>

        <popup-window ref="ppConfirm" :title="'Подтверждение'" :width="600">
            <div class="">
                <div class="form-field">
                    <label class="input-text-lbl">
                        {{confirmText}}
                    </label>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons" style="justify-content: flex-end;">
                    <button type="button" class="btn" @click="confirmOk()">Подтвердить</button>
                    <button type="button" class="btn" @click.stop="closeModal('ppConfirm')">Отмена</button>
                </div>
            </div>
        </popup-window>

        <popup-window ref="ppActionModal" :title="'Обработка ответов'" :modal="true">
          <div class="form-group">
            <p v-if="!actionState.done">
              Ответ {{actionState.currentAnswer.index}} / {{actionState.total}} от {{formatDate(actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm')}} в процессе {{actionState.currentAnswer.time}} сек.
            </p>
            <p v-else>
              <template v-if="actionState.doneMessage">
                {{actionState.doneMessage}}
              </template>
              <template v-else>
                Обработка завершена
              </template>
            </p>
            <div class="margin-top-20" style="max-height:300px;overflow:auto;">
              <p v-for="m of actionState.messages" :style="m.error ? 'color:red': ''" class="caption-help">
                {{m.message}}
              </p>
            </div>
          </div>
          <div class="btns flex margin-top-20" data-toggle="buttons">
            <button type="button" class="btn" @click="ppActionModalClose" v-if="actionState.done || actionState.test">Закрыть</button>
          </div>

        </popup-window>

        <popup-window ref="ppComment" :title="popuptitle" :width="800">
          <div class="">
            <div class="form-field">
              <label class="input-text-lbl"> </label>
              <textarea rows="10"
                        :name="'SettingsDescription'"
                        :class="['input-memo', {'input-error': errors.has('SettingsDescription', 'edition')}]"
                        v-model="commentStatus"
                        v-validate="'required'"
                        data-vv-scope="edition"></textarea>
              <span class="field-validation-valid" v-if="errors.has('SettingsDescription', 'edition')">Заполните поле</span>
            </div>
            <div class="btns flex margin-top-20 margin-bottom-20">
              <button type="button" class="btn" @click="tryChangeStatus()">Принять</button>
              <button type="button" class="btn" @click.stop="closeModal('ppComment')">Отмена</button>
            </div>
          </div>
        </popup-window>

        <popup-window ref="ppConfirmDelete" :title="'Подтверждение удаления'" :modal="true">
          <div class="form-group">
            <p>Вы уверены, что хотите удалить {{ selectedAnswers.length }} {{ getAnswerWord(selectedAnswers.length) }}?</p>
            <div class="btns flex margin-top-20" data-toggle="buttons">
              <button type="button" class="btn btn-danger" @click="confirmDeleteAnswers">Да</button>
              <button type="button" class="btn" @click="cancelDelete">Нет</button>
            </div>
          </div>
        </popup-window>

        <vue-headful title="Задание" />
    </div>
</template>

<script>
    //let $ = require('jquery');

    import $ from 'jquery';
    import BackendApi from '../../backendApi';
    import UI from '../../helpers/ui-helpers';
    import moment from 'moment';
    import { Container, Draggable } from 'vue-smooth-dnd';
    import {TaskTypes, PurposeType, ScoringAccrualTypes, TaskAnswerStates} from '../../enums';
    import imgMixin from '../../helpers/img-mixin'

    window.$ = $;
    window.jQuery = $;

    let backendApi = new BackendApi();
    let DateTypes = {
        /* Дата заполнения */
        FillingDate: 1,
        /* Дата отчета */
        ReportDate: 2,
        /* Дата изменения статуса */
        StatusDate: 3
    };
    let cacheKey = 'answersFilter';
    //let statusRejected = 5;
    let projectIdEinhell = '29';

    export default {
        name: "tasks-edit",

        props: ['info'],

        mixins: [imgMixin],

        components: { Container, Draggable },

        data() {
            return {
                task: null,
                detail: {},
                taskId: null,
                projectId: null,
                bonus: { QntDone: 0},
                file: null,
                answers: [],
                chartOptions: [],
                statusId: 0,
                dateTypeId: DateTypes.FillingDate,
                dateStart: null,
                dateEnd: null,
                statuses: [
                    { Id: 0, Name: 'Все ответы' }, { Id: 1, Name: 'Ждут проверки' }, { Id: 2, Name: 'Проверенные' },
                    { Id: 3, Name: 'Доработанные' }, { Id: 4, Name: 'На доработке' }, { Id: 5, Name: 'Отклоненные' },
                ],
                dateTypes: [
                    { Id: DateTypes.FillingDate, Name: ' Дата заполнения' },
                    { Id: DateTypes.ReportDate, Name: 'Дата изменения ответа' },
                    { Id: DateTypes.StatusDate, Name: 'Дата изменения статуса' }
                ],
                page: 1,
                canBeLoaded: true,
                loading: false,
                scrollTop: null,
                filter: null,
                userFilters: [
                    { Value: 'LastName', Name: 'Фамилия' },
                    { Value: 'FirstName', Name: 'Имя' },
                    { Value: 'MiddleName', Name: 'Отчество' }
                ],
                allowAdd: true,
                canBeShowFIO: false,
                TaskTypes: TaskTypes,
                PurposeType: PurposeType,
                ScoringAccrualTypes: ScoringAccrualTypes,
                isMobile: UI.check_mobile(),
                confirmOperation: '',
                tradePointSelected: {},
                selectAll: false,
                selectedAnswers: [],
                actionState: {
                  currentAnswer: {
                    index: 0,
                    date: null,
                    time: 0
                  },
                  total: 0,
                  messages: [],
                  done: false
                },
                popuptitle: 'Причина отправки на доработку',
                commentStatus: '',
                selectStatus: 0,
            }
        },

        computed: {
            taskAttachmentsImage: function () {
                return this.task.TasksAttachments.filter(x => x.isImage);
            },

            taskAttachmentsNoImage: function () {
                return this.task.TasksAttachments.filter(x => !x.isImage);
            },

            skuBonusList: function () {
                if (this.task)
                    return this.task.SkuBonusList.filter(x => x.Active && x.Bonus > 0);
                else
                    return {};
            },

            confirmText() {
                if (this.confirmOperation === 'setResponsible') {
                    return 'Данное задание необходимо выполнить одному сотруднику в рамках торговой точки. На выполнение задания отведено ' +
                        this.formatTime(this.task.PurposeTimeToComplete) + ' часов. В случае невыполнения задания в указанный срок, повторно выполнить задание Вы можете не ранее чем через ' +
                        this.formatTime(this.task.PurposeAllowAfterComplete) + ' часов с момента невыполнения. Нажимая подтвердить, Вы будете назначены на задание.';
                } else if (this.confirmOperation === 'setRefuse') {
                    return 'В случае если Вы отказываетесь от выполнения задания, то повторно приступить к нему Вы сможете не ранее чем через ' +
                        this.formatTime(this.task.PurposeAllowAfterComplete) + ' часов. Вы точно хотите отказаться от выполнения задания?';
                }
            },

            pageInfoMessage() {
                if (this.task.DenyExecutionOnSite)
                    return 'Выполнение задания на сайте запрещено. Пожалуйста, добавьте ответ через мобильное приложение.';
                else if (this.task.PurposeOneAnswerTT && this.detail.AllowResponsibleAdd && !this.detail.ResponsibleBlock)
                    return 'Задание доступно до ' + this.detail.DateEndStr;
                else 
                    return '';
            },

            exportEnabled() {
                //console.info('exportEnabled', this.info, this.projectId, projectIdEinhell)
                if(this.info && this.projectId == projectIdEinhell)
                    return this.info.User.MainRole === 'administrators' ||
                        (this.info.User.DynamicRole && (this.info.User.DynamicRole.Name === 'Клиент' || this.info.User.DynamicRole.Name === 'Аналитик'));
                else
                    return null;
            }
        },

        methods: {
            back() {
                //this.$router.back();
                this.$router.push('/tasks');
            },

            getStateClass(item) {
                return 'task-state-' + item.LastStatus;
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            addAnswer() {
                let vm = this;
                let id = parseInt(this.$route.params.id);
                if (vm.task.DenyExecutionOnSite) {
                    UI.toastr.error('Выполнение задания на сайте запрещено. Пожалуйста, добавьте ответ через мобильное приложение.');
                } else if (vm.task.PurposeOneAnswerTT) {
                    vm.onChangeTPSearch({ Name: vm.detail.SelectedTradePoint.Name, Id: vm.detail.SelectedTradePoint.Id}, null, null).then(() => {
                        if (vm.detail.ResponsibleBlock) {
                            if (vm.detail.BalanceToUnlock > 0)
                                UI.toastr.error('Время на выполнение задания истекло. Повторно взять задание в работу Вы можете не ранее чем через ' +
                                    vm.formatTime(vm.detail.BalanceToUnlock) + ' часов.');
                        } else {
                            this.$router.push('/tasks/answer/' + id + '/0/add?tpid=' + vm.detail.SelectedTradePoint.Id);
                        }
                    });
                } else {
                    this.$router.push('/tasks/answer/' + id + '/0/add?tpid=' + vm.detail.SelectedTradePoint.Id);
                }
            },

            editAnswer(answerId, status) {
                let vm = this;
                let id = parseInt(this.$route.params.id);
                //console.info('editAnswer', vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend), vm.info.User);
                if (vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
                    if (status == 4)
                        this.$router.push('/tasks/answer/' + id + '/' + answerId + '/edit');
                    else
                        this.$router.push('/tasks/answer/' + id + '/' + answerId + '/view');
                }
                else if (!vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController) && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit))
                    this.$router.push('/tasks/answer/' + id + '/' + answerId + '/view');
                else
                    this.$router.push('/tasks/answer/' + id + '/' + answerId + '/checking');
            },

            confirmShow(operation) {
                this.confirmOperation = operation;
                if (operation === 'setResponsible') {
                    this.$validator.validate().then(result => {
                        if (!result) {
                            UI.toastr.error('Необходимо выбрать торговую точку');
                        } else {
                            this.onShowModal('ppConfirm');
                        }
                    });
                } else {
                    this.onShowModal('ppConfirm');
                }
            },

            confirmOk() {
                let vm = this;
                if (vm.confirmOperation === 'setResponsible') {
                    vm.setResponsible();
                } else if (vm.confirmOperation === 'setRefuse') {
                    vm.setRefuse();
                }
            },

            setResponsible() {
                let vm = this;
                UI.blockUI('.dataContent', 'Назначение ответственным...' + vm.confirmOperation);
                backendApi.tasksResponsible(vm.task.Id, vm.confirmOperation, vm.detail.SelectedTradePoint.Id).then(function (response) {
                    UI.unblockUI('.dataContent');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при назначении ответственным');
                    } else {
                        vm.detail.ResponsibleBlock = response.data.ResponsibleBlock;
                        vm.detail.BalanceToUnlock = response.data.BalanceToUnlock;
                        vm.detail.ResponsibleId = response.data.ResponsibleId;
                        vm.detail.AllowResponsibleAdd = response.data.AllowResponsibleAdd;
                        vm.detail.AnswerBtnAddText = response.data.AnswerBtnAddText;
                        if (response.data.DateEnd) {
                            vm.detail.DateEndStr = moment(response.data.DateEnd).format('DD-MM-YYYY HH:mm');
                        }

                        if (vm.detail.ResponsibleBlock) {
                            UI.toastr.error('Задание уже находится в работе у одного из сотрудников торговой точки.');
                        } else if (!vm.detail.ResponsibleId) {
                            UI.toastr.success('Вы успешно назначены ответственным на задание');
                            vm.detail.ResponsibleId = vm.info.User.Id;
                        } 
                    }
                    vm.closeModal('ppConfirm');
                });
            },

            setRefuse() {
                let vm = this;
                UI.blockUI('.dataContent', 'Отказ от ответственности...' + vm.confirmOperation);
                backendApi.tasksResponsibleRefuse(vm.task.Id, vm.detail.SelectedTradePoint.Id).then(function (response) {
                    UI.unblockUI('.dataContent');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при отказе от ответственности');
                    } else {
                        UI.toastr.success('Вы отказались от ответственности на задание');
                        vm.detail.ResponsibleBlock = true;
                    }
                    vm.closeModal('ppConfirm');
                });
            },

            moreSKU() {
                this.onShowModal('ppSkuList');
            },

            onStatusChange() {
                this.reload();
                this.saveFilterState();
            },

            onDateChange() {
                this.reload();
                this.saveFilterState();
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {
                let filterFormatted = '';
                if (filters) {
                    filterFormatted = this.CommonMixin_UsersProcessFilter(filters).map(x => { return JSON.stringify(x) });
                }
                //console.info(filters, filterFormatted);
                this.callApiWrapper(backendApi.tasksDistinctValues(columnName, this.projectId, this.taskId, search, filterFormatted,
                    (searchPage - 1) * 30, 30))
                    .then(function (resp) {
                        callback(resp.data);
                    })
            },

            reload() {
                this.page = 1;
                this.answers = [];
                this.loading = false;
                this.canBeLoaded = true;
                this.selectedAnswers = [];
                this.loadAnswers();
            },

            loadTask() {
                let vm = this;
                vm.taskId = parseInt(this.$route.params.id);
                vm.projectId = localStorage.getItem('selectedProjectId');
                vm.canBeShowFIO = vm.info.User.MainRole === 'administrators' || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController) ||
                    vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit) || !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend);
                return backendApi.tasksLoad(vm.taskId, true).then(function (response) {
                    //console.info('project.edit -> load, response:', response.data);
                    if (response.hasError) {
                        if (response.status === 403) {
                            UI.toastr.error('Запрещено');
                            vm.$router.back();
                        } else
                            UI.toastr.error('Ошибка при загрузке задания');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }

                        vm.task = Object.assign(response.data.task);
                        vm.task.CaptionFormatted = vm.task.Caption ? vm.task.Caption.replace(/\n/g, '<br>') : null;
                        vm.task.StartDateFormatted = moment(vm.task.StartDate).format('DD.MM.YYYY');//.format('LL');
                        if (vm.task.EndDate) {
                            vm.task.EndDateFormatted = moment(vm.task.EndDate).format('DD.MM.YYYY');
                        }
                        if (vm.task.ScoringBurningDate) {
                            vm.task.ScoringBurningDateFormatted = moment(vm.task.ScoringBurningDate).format('DD.MM.YYYY');
                        }
                        vm.task.TasksAttachments.forEach(x => {
                            x.Extension = x.FileName.toLowerCase().split('.').pop();
                        });

                        if (response.data.detail) {
                            let responsibleBlock = vm.detail.ResponsibleBlock;
                            vm.detail = Object.assign(response.data.detail);
                            if (responsibleBlock) {
                                vm.detail.ResponsibleBlock = responsibleBlock;
                            }
                            if (vm.detail.DateEnd) {
                                vm.detail.DateEndStr = moment(vm.detail.DateEnd).format('DD-MM-YYYY HH:mm');
                            }
                            if (vm.task.DenyExecutionOnSite) {
                                vm.detail.ResponsibleBlock = true;
                            }
                        }
                        if (vm.task.EndDate < vm.task.Now || vm.task.StartDate > vm.task.Now) {
                            vm.allowAdd = false;
                        } else if (vm.allowAdd) {
                            vm.allowAdd = vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend);// && !vm.detail.ResponsibleBlock;
                        }
                        //console.info('this.task.Files', vm.allowAdd && vm.task.PurposeOneAnswerTT, vm.detail.ResponsibleId, vm.info.User.Id);
                    }
                })
            },

            loadAnswers() {
                let vm = this;
                let timeZone = new Date().getTimezoneOffset();
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                this.loading = true;
                var projectId = localStorage.getItem('selectedProjectId');
                UI.blockUI('.dataContent', 'Загрузка...');
                this.callApiWrapper(backendApi.tasksAnswers((this.page - 1) * 20, 20, projectId, vm.taskId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, vm.CommonMixin_UsersProcessFilter(vm.filter)))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки ответов');
                        }
                        else {
                            if (resp.data.list && resp.data.list.length) {
                              vm.answers.push(...resp.data.list);
                                //console.info('vm.answers', vm.answers.lengthm, vm.isMobile);
                            }
                            else {
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
            },

            loadBonus() {
                let vm = this;
                UI.blockUI('.dataContent', 'Загрузка...');
                this.callApiWrapper(backendApi.tasksBonus(vm.taskId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки бонусов');
                        }
                        else {
                            vm.bonus = Object.assign(resp.data.bonus);
                            if (vm.bonus.PurposeValue === 0) {
                                vm.detail.ResponsibleBlock = true;
                            }
                        }
                        UI.unblockUI('.dataContent');
                    })
            },

            clearFilterState() {
                this.dateStart = '';
                this.dateEnd = '';
                this.statusId = '';
                this.dateTypeId = DateTypes.FillingDate;

                localStorage.removeItem(cacheKey);
                this.reload();
            },

            saveFilterState() {
                //console.info('this.statusId:', this.statusId);

                let stateObj = {
                    statusId: this.statusId,
                    dateTypeId: this.dateTypeId,
                    dateStart: this.dateStart,
                    dateEnd: this.dateEnd,
                    page: this.page,
                    scrollTop: this.scrollTop
                };
                localStorage.setItem(cacheKey, JSON.stringify(stateObj));
            },

            recoverFilterState() {
                let stateObj = JSON.parse(localStorage.getItem(cacheKey));
                //console.info('recoverFilterState -> stateObj:', stateObj);
                if (stateObj) {
                    if (stateObj.statusId != null) {
                        this.statusId = stateObj.statusId;
                    }
                    if (stateObj.dateTypeId) {
                        this.dateTypeId = stateObj.dateTypeId;
                    }
                    if (stateObj.dateStart) {
                        this.dateStart = stateObj.dateStart;
                    }
                    if (stateObj.dateEnd) {
                        this.dateEnd = stateObj.dateEnd;
                    }
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                    if (stateObj.scrollTop) {
                        this.scrollTop = stateObj.scrollTop;
                    }
                }
            },

            onScroll(e) {
                let vm = this;
                if (!vm.loading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    vm.scrollTop = elem.scrollTop();
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.page++;
                        vm.loadAnswers();
                    }
                }
            },

            onFilterChange(filter) {
                this.filter = filter;
                this.answers = [];
                this.loading = false;
                this.canBeLoaded = true;
                this.page = 1;

                this.loadAnswers();
            },

            // https://momentjs.com/docs/#/displaying/format/
            formatTime(seconds) {
                let h = Math.floor(seconds / 3600);
                let m = Math.floor((seconds - h * 3600) / 60);
                let s = Math.floor(seconds - h * 3600 - m * 60);

                return (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m) + ':' + (s > 9 ? s : '0' + s);

                //if (seconds > 86400)
                //    return moment().startOf('day').startOf('year').add(-1, 'day').seconds(seconds).format('DDD HH:mm:ss');
                //else
                //    return moment().startOf('day').seconds(seconds).format('HH:mm:ss');
            },

            getTPSelectedItem() {
                return {
                    Id: this.detail.SelectedTradePoint.Id,
                    Name: this.detail.SelectedTradePoint.Name
                }
            },

            searchTPFunction(searchText, callback, extra, page) {
                let vm = this;
                //console.info('searchTPFunction', searchText, page, extra);
                vm.callApiWrapper(backendApi.tradePointSearch((page - 1) * 20, 20, vm.projectId, searchText))
                    .then(function (resp) {
                        callback(resp.data);
                    });
            },

            onChangeTPSearch(listItem, extra, skuLink) {
                if (listItem) {
                    let vm = this;
                    vm.detail.SelectedTradePoint.Id = listItem.Id;
                    vm.detail.SelectedTradePoint.Name = listItem.Name;

                    UI.blockUI('.dataContent', 'Загрузка...');
                    return this.callApiWrapper(backendApi.taskCheckResponsible(vm.taskId, listItem.Id))
                        .then(function (resp) {
                            if (!resp.hasError) {
                                vm.detail.ResponsibleBlock = resp.data.ResponsibleBlock;
                                vm.detail.BalanceToUnlock = resp.data.BalanceToUnlock;
                                vm.detail.ResponsibleId = resp.data.ResponsibleId;
                                vm.detail.AllowResponsibleAdd = resp.data.AllowResponsibleAdd;
                                vm.detail.AnswerBtnAddText = resp.data.AnswerBtnAddText;
                                if (resp.data.DateEnd) {
                                    vm.detail.DateEndStr = moment(resp.data.DateEnd).format('DD-MM-YYYY HH:mm');
                                }

                                if (!vm.detail.ResponsibleBlock &&
                                    (vm.task.DenyExecutionOnSite || vm.bonus.TradePointsIds.filter(x => x === listItem.Id).length === 0)) {
                                    vm.detail.ResponsibleBlock = true;
                                }
                            }
                            UI.unblockUI('.dataContent');
                        })
                } else {
                    return new Promise(resolve => resolve());
                }
            },

            onDetailExport() {
                let vm = this;

                let timeZone = new Date().getTimezoneOffset();
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();

                UI.blockUI('.dataContent', 'Выгрузка...');
                this.callApiWrapper(backendApi.tasksDetailExport(vm.task.Id,vm.statusId, vm.dateTypeId, dateStart, dateEnd, vm.CommonMixin_UsersProcessFilter(vm.filter)))
                    .then(function (resp) {
                        if(resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                            console.info('resp', resp);
                        }
                        else {
                            let exportFile = resp.data;
                            if(exportFile != null) {
                                UI.downloadFileByBytes(resp.data, "Выгрузка по ответам.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                            }
                        }
                        UI.unblockUI('.dataContent');
                    });
            },

            onSelectAllChange(e) {
              let vm = this;

              vm.selectedAnswers = [];
              if (vm.selectAll) {
                for (let answer of vm.answers) {
                  vm.selectedAnswers.push(answer);
                }
              }
            },

            onCheckChange(item) {
              let vm = this;
              if (vm.selectedAnswers.filter(x => x == item).length === 0) {
                vm.selectAll = false;
              } else if (vm.selectedAnswers.length === vm.answers.length) {
                vm.selectAll = true;
              }
            },

            selectedCancel() {
              this.selectAll = false;
              this.selectedAnswers = [];
            },

            ppActionModalClose() {
              this.closeModal('ppActionModal');
              this.reload();
            },

            btnReject(state) {
              let vm = this;
              vm.selectStatus = state;
              vm.commentStatus = '';

              if (state === 4)
                vm.popuptitle = 'Причина отправки на доработку';
              else
                vm.popuptitle = 'Причина отклонения';
              vm.$refs['ppComment'].show();
            },

            removeAnswers() {
              let vm = this;
              vm.showConfirmDeleteModal();
            },

            showConfirmDeleteModal() {
              this.$refs.ppConfirmDelete.show();
            },

            async confirmDeleteAnswers() {
              let vm = this;
              await vm.updateMultipleAnswerStatuses(TaskAnswerStates.Remove, '');
              vm.closeModal('ppConfirmDelete');
            },

            cancelDelete() {
              this.$refs.ppConfirmDelete.hide();
            },

            tryChangeStatus() {
              let vm = this;
              vm.closeModal('ppComment');
              this.updateMultipleAnswerStatuses(vm.selectStatus, vm.commentStatus)
            },

            getAnswerWord(count) {
              if (count % 10 === 1 && count % 100 !== 11) {
                return 'ответ';
              } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
                return 'ответа';
              } else {
                return 'ответов';
              }
            },

            updateMultipleAnswerStatuses(status, comment) {
              let vm = this;
              if (vm.selectedAnswers.length === 0)
                return;

              let statusLabel;
              switch (status) {
                case TaskAnswerStates.Accepted:
                  statusLabel = "Принято";
                  break;
                case TaskAnswerStates.OnEdition:
                  statusLabel = "Отправлено на доработку";
                  break;
                case TaskAnswerStates.Rejected:
                  statusLabel = "Отклонено";
                  break;
                case TaskAnswerStates.Remove:
                  statusLabel = "Удалено";
                  break;
                default:
                  statusLabel = "Неизвестный статус";
                  break;
              }

              let selectedAnswers = this.selectedAnswers.map(x => {
                return {
                  Id: x.Id,
                  TaskId: x.TaskId,
                  Status: status,
                  EditionComment: comment,
                  Date: x.DateStatus,
                }
              });

              vm.actionState = {
                currentAnswer: {
                  index: 0,
                  date: null,
                  time: 0
                },
                total: 0,
                messages: [],
                done: false
              };

              vm.$refs.ppActionModal.show();

              (async function loop() {
                UI.blockUI('dataContent', 'Обработка');

                let secondsInterval;
                vm.actionState.total = selectedAnswers.length;
                for (let answer of selectedAnswers) {
                  console.log(vm.actionState.currentAnswer.index)
                  vm.actionState.currentAnswer.index++;
                  vm.actionState.currentAnswer.time = 0;
                  vm.actionState.currentAnswer.date = answer.Date;

                  secondsInterval = setInterval(function () {
                    vm.actionState.currentAnswer.time += 1;
                  }, 1000);
                  await vm.callApiWrapper(backendApi.tasksAnswerAccept(answer.TaskId, answer.Id, answer.Status, answer.EditionComment))

                      .then(function (response) {
                        clearInterval(secondsInterval);

                        let answerTitle = `Ответ ${vm.actionState.currentAnswer.index} от ${vm.formatDate(vm.actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm')}`;

                        if(response.hasError) {
                          switch(response.status) {
                            case 722:
                              vm.actionState.messages.push({
                                message: `${answerTitle}: Отправить на доработку можно только тот ответ, по которому бонусы не были истрачены`,
                                error: true
                              });
                              break;
                            case 723:
                              vm.actionState.messages.push({
                                message: `${answerTitle}: Отклонить можно только тот ответ, по которому бонусы не были истрачены`,
                                error: true
                              });
                              break;
                            case 724:
                              vm.actionState.messages.push({
                                message: `${answerTitle}: Удалить можно только тот ответ, по которому бонусы не были истрачены`,
                                error: true
                              });
                              break;
                            default:
                              vm.actionState.messages.push({
                                message: `${answerTitle}: Ошибка при сохранении`,
                                error: true
                              });
                              break;
                          }
                        } else {
                          vm.actionState.messages.push({message: `${answerTitle}: ${statusLabel}`});
                        }
                        if (vm.actionState.currentAnswer.index === vm.actionState.total) {
                          vm.actionState.done = true;
                          UI.unblockUI('dataContent');
                        }
                      });
                }
              })();
            },
        },

        mounted() {
            let vm = this;

            vm.recoverFilterState();

            UI.blockUI('.dataContent', 'Загрузка...');

            Promise.all([this.loadTask(), this.loadAnswers(), this.loadBonus()]).then(() => {
                UI.unblockUI('.dataContent');
                vm.imgmixin_lightzoomInit();
            });
        },

        destroyed(){
            $(document).off('change', '[name="dropFiles"]');
            $(document).off('click', '.block-in-page-collapce');
        }
    }
</script>

<style scoped>
  .btn {
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// Content/src/views/details/TasksDetails.vue